import { useAppMessageSender } from "@albertine/wrapper-interop/react";
import { createFileRoute, notFound } from "@tanstack/react-router";
import type { Tenant } from "albertine-shared-web";
import { LoginHelpPage } from "./-components/LoginHelpPage";

export const Route = createFileRoute("/help/")({
    beforeLoad: () => {
        document.documentElement.style.setProperty(
            "--color-body-top",
            "var(--color-background-onboarding)",
        );
        document.documentElement.style.setProperty(
            "--color-body-bottom",
            "var(--color-background-onboarding)",
        );
    },

    component: RouteComponent,

    head: ({ match }) => {
        const { tenant, locale } = match.search;
        return {
            meta: [
                {
                    title: `Help - ${tenant} ${locale}`,
                },
            ],
        };
    },

    onError: () => {
        throw notFound();
    },
});

function RouteComponent() {
    const { tenant } = Route.useSearch();
    const sendAppMessage = useAppMessageSender();

    return (
        <div className="relative mx-auto flex h-full min-h-0 w-full max-w-small-content flex-col py-safe">
            <LoginHelpPage
                tenant={tenant as Tenant}
                onBack={() => sendAppMessage("navigateBack")}
            />
        </div>
    );
}
